<template>
  <b-modal
    id="cancel-subscription-modal"
    ref="cancel-subscription-modal"
    modal-class="atto-modal"
    size="invite-member"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="atto-modal">
      <div class="modal-text">
        <div class="modal-text-header">
          <span></span>
        </div>
        <div class="modal-text-body">
          <h1>{{ label.get("we_will_miss_you") }}, {{ name }}!</h1>
          <p class="seats-desc">
            {{ label.get("billing_cancel_subscription_title") }}
          </p>
          <p
            class="seats-desc"
            v-html="
              label.get(
                'billing_cancel_subscription_cancellation_will_be_effective',
                { nextPayment: nextPayment }
              )
            "
          />
        </div>
        <div class="modal-text-footer">
          <Button class="contact-support-button" @click="feedbackAndSupport">
            <span>{{ label.get("contact_support") }}</span>
            <img src="~@assets/images/right-arrow.svg" alt="Right Arrow" />
          </Button>
        </div>
      </div>
      <div class="modal-actions">
        <div class="modal-actions-header">
          <h3>
            {{ label.get("before_you_go_description") }}
          </h3>
        </div>
        <div class="modal-actions-body">
          <div
            class="check-wrapper"
            v-for="(feedback, index) in feedbacksText"
            :key="index"
          >
            <b-form-radio
              class="radio-style"
              name="feedback_id"
              :value="feedback.value"
              @change="onChangeRadio($event)"
            >
              {{ feedback.label }}
            </b-form-radio>
          </div>
          <span v-if="radioError" class="error-message">{{
            label.get("please_select_response_before_cancelling")
          }}</span>
          <textarea
            :placeholder="label.get('anything_else_you_want_to_share')"
            v-model="comment"
            maxlength="190"
          ></textarea>
          <span v-if="commentError" class="error-message">{{
            label.get("please_add_a_comment")
          }}</span>
        </div>
        <div class="modal-actions-footer">
          <Button @click="close">{{ label.get("not_now") }}</Button>
          <Button
            v-bind:class="{
              btnInactive: feedBackValue === null,
              btnActive: feedBackValue !== null,
            }"
            @click="confirmCancel"
            >{{ label.get("cancel") }}</Button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import BillingService from "../services/BillingService";
import { required, sameAs } from "vuelidate/lib/validators";
export default {
  name: "CancelSubscriptionComponent",
  props: {
    nextPayment: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: this.$store.state.user.name,
      disabled: false,
      feedbacksText: [
        {
          value: 1,
          label: this.label.get("feature_was_missing"),
        },
        {
          value: 2,
          label: this.label.get("it_is_to_expensive"),
        },
        {
          value: 3,
          label: this.label.get("experienced_technical_issues"),
        },
        {
          value: 4,
          label: this.label.get("running_seasonal_business"),
        },
        {
          value: 5,
          label: this.label.get("business_is_shutting_down"),
        },
        {
          value: 6,
          label: this.label.get("switching_to_another_product"),
        },
        {
          value: 7,
          label: this.label.get("i_no_longer_need_it"),
        },
        {
          value: 8,
          label: this.label.get("other_please_explain_below"),
        },
      ],
      feedBackValue: null,
      comment: "",
      radioError: false,
      commentError: false,
    };
  },

  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["cancel-subscription-modal"].show();
  },
  methods: {
    confirmCancel() {
      this.disabled = true;

      this.radioError = false;
      this.commentError = false;

      if (this.feedBackValue === null) {
        this.radioError = true;
        return false;
      }

      if (this.feedBackValue === 8 && this.comment === "") {
        debugger;
        this.commentError = true;
        return false;
      }

      var params = {
        feedback_id: this.feedBackValue,
        comment: this.comment,
      };
      this.$store.commit("showLoading");
      BillingService.cancelSubscription(params)
        .then((result) => {
          this.disabled = false;
          this.$store.commit("hideLoading");
          this.$root.$emit("hideCancelSubscription", true);
        })
        .catch((error) => {
          debugger;
          this.disabled = false;
          this.$store.commit("hideLoading");
        });
    },
    close() {
      this.$root.$emit("hideCancelSubscription", false);
    },
    onChangeRadio(value) {
      this.feedBackValue = value;
    },
    feedbackAndSupport() {
      this.$root.$emit("showFeedbackModal");
    },
  },
};
</script>
<style lang="scss">
/* @media queries */
@mixin modalMaxScreen {
  @media (max-width: 860px) {
    @content;
  }
}
@mixin tablet {
  @media (max-width: 767px) and (min-width: 481px) {
    @content;
  }
}
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */

.atto-modal {
  width: 100%;
  height: auto;
  display: flex;
  padding-right: 0px !important;
  @include mobile {
    flex-direction: column;
  }
  .modal-invite-member {
    max-width: 840px !important;
    width: 100% !important;
    height: auto;
    @include modalMaxScreen {
      width: 95% !important;
    }
    @include tablet {
      width: 100% !important;
    }
    @include mobile {
      width: 100% !important;
    }
    .modal-text-content,
    .modal-actions-content {
      width: 100%;
      background: #fff;
      border-radius: 0;
      border-color: #fff;
      display: flex;
      justify-content: center;
      flex-direction: row;
      .modal-text-body,
      .modal-actions-body {
        .modal-text-footer,
        .modal-actions-footer {
          @include tablet {
            padding: 40px;
          }
          @include mobile {
            padding: 20px;
          }
        }
      }
    }
  }
  .modal-text,
  .modal-actions {
    width: 50%;
    @include mobile {
      width: 100%;
    }
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .modal-text-header,
    .modal-actions-header,
    .modal-text-body,
    .modal-actions-body,
    .modal-text-footer,
    .modal-actions-footer {
      padding: 40px;
      @include tablet {
        padding: 20px;
      }
      @include mobile {
        padding: 20px;
      }
    }
    .modal-text-header,
    .modal-actions-header {
      border-bottom: none;
    }
    .modal-text-body,
    .modal-actions-body {
      padding: 0 40px;
      @include tablet {
        padding: 0 20px;
      }
      @include mobile {
        padding: 0 20px;
      }
    }
    .modal-text-footer,
    .modal-actions-footer {
      border-top: none;
    }
  }

  /* Modal Text */
  .modal-text {
    background: #efefef;
    .modal-text-header {
      display: flex;
      flex-direction: column;
      span {
        width: 93px;
        height: 87px;
        background: url("~@assets/images/no-receipts.svg") no-repeat;
      }
    }
    .modal-text-body {
      height: 100%;
      h1 {
        margin-bottom: 14px;
        font-size: 20px;
        line-height: 28px;
        color: #262626;
        font-weight: $roboto-bold;
      }
      p {
        margin-bottom: 25px;
        font-size: 16px;
        line-height: 24px;
        font-weight: $roboto-regular;
      }
    }
    .modal-text-footer {
      justify-content: flex-start;
      @include tablet {
        display: none;
      }
      @include mobile {
        display: none;
      }
      button {
        position: relative;
        width: auto;
        background: none;
        border: none;
        color: #262626;
        padding: 0;
        display: flex;
        align-items: center;
        &:hover {
          color: #000;
        }
        span {
          padding-right: 7px;
          font-size: 13px;
          line-height: 24px;
          font-weight: $roboto-medium;
        }
        img {
          width: 10px;
          height: 10px;
        }
      }
    }
  }
  /* End of: Modal Text */

  /* Modal Actions */
  .modal-actions {
    .modal-actions-header {
      padding-bottom: 16px;
      h3 {
        font-size: 14px;
        line-height: 20px;
        color: #262626;
        font-weight: $roboto-regular;
      }
    }
    .modal-actions-body {
      .check-wrapper {
        padding-left: 40px;
        .custom-radio {
          padding-left: 0;
        }
        .custom-control {
          padding-left: 0;
        }
        .radio-style {
          .custom-control-label {
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 26px;
            margin-bottom: 8px;
            font-size: 14px;
            line-height: 16px;
            font-family: $roboto-font;
            font-weight: $roboto-regular;
          }
        }
      }
      textarea {
        width: 100%;
        min-height: 84px;
        height: auto;
        margin-top: 8px;
        padding: 12px;
        border: 1px solid #c7c7c7;
        &:focus {
          outline: none;
          border: 1px solid #c7c7c7;
        }
        &::placeholder {
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
        }
      }
    }
    .modal-actions-footer {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      button {
        width: calc(50% - 8px);
        @include tablet {
          width: calc(50% - 6px);
          font-size: 0.875rem;
        }
        height: 40px;
        border-radius: 0;
        border: none;
        text-transform: uppercase;
        font-size: 1rem;
        line-height: 2.5rem;
        &:first-child {
          background: #efefef;
          color: #999;
          font-weight: $roboto-bold;
          &:hover {
            background: #e1e1e3;
          }
        }
      }
    }
    .btnInactive {
      background-color: #e05656;
      color: #fff;
      font-weight: $roboto-bold;
      opacity: 0.5;
    }
    .btnActive {
      background-color: #e05656;
      color: #fff;
      font-weight: $roboto-bold;
      opacity: 1;
    }
  }
  /* End of: Modal Actions */
}
</style>
